import axios from "./axios";
import { AxiosReturn } from "./types";
import * as Requests from "./requests";
import { ICompetitionCreate } from "../types";

export const getCompetition = (
  id,
  token
): AxiosReturn<{ competition: ICompetitionCreate }> => {
  return axios.get(Requests.getLeaderBoards(id), {
    baseURL: process.env.REACT_APP_LUMEN_ENDPOINT,
    headers: {
      token,
    },
  });
};
